


























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import GoodSelect from '@/components/goods-select/index.vue'
import PicModal from '@/components/upload/picModal.vue'
@Component({
  components: {
    GoodSelect,
    PicModal
  }
})
export default class OutfixProduct extends Vue {
  @Prop({
    type: Array,
    default: () => [
      {
        outfitPrice: '',
        pictureUrl: '',
        promotionOutfitId: '',
        promotionOutfitProducts: [
          {
            promotionOutfitId: '',
            productId: '',
            pictureUrl: '',
            productName: '',
            brandName: '',
            productCode: '',
            marketPrice: 0,
            price: 0,
            displayOrder: 0
          }
        ]
      }
    ]
  })
  outfits!: any[]
  columns = [
    {
      title: '商品名称',
      key: 'productName'
    },
    {
      title: '图片',
      key: 'pictureUrl',
      slot: 'pictureUrl',
      width: 100
    },
    {
      title: '款号',
      key: 'productCode',
      width: 160
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
      width: 120
    }
  ]
  deleteOutfit(index) {
    this.outfits.splice(index, 1)
  }
  deleteItem(index, productIndex) {
    this.outfits[index].promotionOutfitProducts.splice(productIndex, 1)
  }
  picChange(index, e) {
    console.log('e: ', e)
    this.outfits[index].pictureUrl = e[0].url
  }
  onProductChange(index, e) {
    console.log('e: ', e)
    e.forEach(t => {
      this.outfits[index].promotionOutfitProducts.push({
        promotionOutfitId: this.outfits[index].promotionOutfitId,
        productId: t.id,
        pictureUrl: t.pictureUrl,
        productName: t.name,
        brandName: t.brandName,
        productCode: t.code,
        marketPrice: t.marketPrice,
        price: t.price,
        displayOrder: 0
      })
    })
  }
  addOutfix() {
    this.outfits.push({
      outfitPrice: null,
      pictureUrl: '',
      promotionOutfitId: '',
      promotionOutfitProducts: [
        // {
        //   promotionOutfitId: '',
        //   productId: '',
        //   pictureUrl: '',
        //   productName: '',
        //   brandName: '',
        //   productCode: '',
        //   marketPrice: 0,
        //   price: 0,
        //   displayOrder: 0
        // }
      ]
    })
  }
  save() {
    this.$emit('on-submit')
  }
}
